(function () {
  function isSlideVisible(slide) {
    if (!slide) return false;
    return slide.offsetParent !== null && getComputedStyle(slide).display !== 'none';
  }

  function getBadgeHostContainer(sectionId, variantId) {
    const gallery = document.getElementById(`MediaGallery-${sectionId}`);
    if (!gallery) return null;

    const vid = variantId ? String(variantId) : null;
    const slides = Array.from(gallery.querySelectorAll('.product__media-item'));

    if (vid && window.innerWidth <= 768) {
      const variantSlides = slides.filter(
        (slide) => slide.classList.contains(`idCustom-${vid}`) && isSlideVisible(slide)
      );
      if (variantSlides.length) {
        return (
          variantSlides[0].querySelector('.product__modal-opener--image') ||
          variantSlides[0].querySelector('.product-media-container')
        );
      }
    }

    if (vid) {
      const dataSlides = slides.filter(
        (slide) => slide.dataset.variantid === vid && isSlideVisible(slide)
      );
      if (dataSlides.length) {
        return (
          dataSlides[0].querySelector('.product__modal-opener--image') ||
          dataSlides[0].querySelector('.product-media-container')
        );
      }
    }

    const visibleSlides = slides.filter(isSlideVisible);
    const activeSlide =
      visibleSlides.find((slide) => slide.classList.contains('is-active')) ||
      visibleSlides.find((slide) => slide.classList.contains('default_li_selected')) ||
      visibleSlides[0];

    if (!activeSlide) return null;

    return (
      activeSlide.querySelector('.product__modal-opener--image') ||
      activeSlide.querySelector('.product-media-container')
    );
  }

  function syncBadgeHost(sectionId, variantId) {
    const badges = document.getElementById(`ProductBadges-${sectionId}`);
    if (!badges) return;

    const hostContainer = getBadgeHostContainer(sectionId, variantId);
    if (!hostContainer || badges.parentElement === hostContainer) return;

    hostContainer.appendChild(badges);
  }

  function updateProductBadges(variantId, sectionId) {
    if (!variantId || !sectionId) return;

    const container = document.getElementById(`ProductBadges-${sectionId}`);
    const dataEl = document.getElementById(`VariantBadgesData-${sectionId}`);

    if (!container || !dataEl) return;

    try {
      const map = JSON.parse(dataEl.textContent);
      container.innerHTML = map[String(variantId)] || '';
    } catch (error) {
      /* no-op */
    }

    syncBadgeHost(sectionId, variantId);
    window.setTimeout(() => syncBadgeHost(sectionId, variantId), 200);
    window.setTimeout(() => syncBadgeHost(sectionId, variantId), 500);
  }

  function initGalleryBadgeSync(sectionId) {
    const gallery = document.getElementById(`MediaGallery-${sectionId}`);
    if (!gallery) return;

    const viewer = gallery.querySelector('[id^="GalleryViewer"]');
    viewer?.addEventListener('slideChanged', () => {
      const variantId =
        document.querySelector(`#MainProduct-${sectionId} input[name="id"]`)?.value ||
        new URLSearchParams(window.location.search).get('variant');
      window.requestAnimationFrame(() => syncBadgeHost(sectionId, variantId));
    });
  }

  function syncAllProductBadges() {
    document.querySelectorAll('media-gallery[id^="MediaGallery-"]').forEach((gallery) => {
      const sectionId = gallery.id.replace(/^MediaGallery-/, '').replace(/-duplicate$/, '');
      if (!sectionId || gallery.id.endsWith('-duplicate')) return;

      const productRoot = gallery.closest('.product');
      const variantId =
        productRoot?.querySelector('input[name="id"]')?.value ||
        new URLSearchParams(window.location.search).get('variant');

      syncBadgeHost(sectionId, variantId);
      initGalleryBadgeSync(sectionId);
    });
  }

  function initVariantBadges() {
    syncAllProductBadges();

    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') {
      return;
    }

    subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
      const variantId = event?.data?.variant?.id;
      const sectionId = event?.data?.sectionId;

      if (!variantId || !sectionId) return;

      window.requestAnimationFrame(() => {
        updateProductBadges(variantId, sectionId);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initVariantBadges);
  } else {
    initVariantBadges();
  }

  window.addEventListener('load', () => {
    window.setTimeout(syncAllProductBadges, 100);
    window.setTimeout(syncAllProductBadges, 400);
  });

  window.syncProductBadgesHost = syncBadgeHost;
})();
